import { useState } from "react";
import { API, getToken } from "@/lib/api";
import * as Icons from "lucide-react";

export function CoverThumb({ path, alt, icon = "HardHat", tile = "bg-emerald-50 text-emerald-600", testId }) {
  const [broken, setBroken] = useState(false);
  const I = Icons[icon];
  if (path && !broken)
    return <img src={`${API}${path}?auth=${getToken()}`} alt={alt || ""} loading="lazy" onError={() => setBroken(true)}
      className="h-12 w-16 shrink-0 rounded-lg border border-slate-200 object-cover" data-testid={`${testId}-photo`} />;
  return <span className={`inline-flex h-12 w-16 shrink-0 items-center justify-center rounded-lg ${tile}`} data-testid={`${testId}-nophoto`}><I className="h-5 w-5" /></span>;
}
